import Router from './util/Router'
import common from './routes/common'
import home from './routes/home'
import about from './routes/about'
import team from './routes/team'
// import locations from './routes/locations'
import contact from './routes/contact'
import barBites from './routes/menu'
import mainMenu from './routes/menu'
import wineMenu from './routes/menu'
import taxMenuCategories from './routes/menu'

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
	/** All pages */
	common,
	/** Home page */
	home,
	/** About page */
	about,
	/** About Us page, note the change from about-us to aboutUs. */
	team,
	/** Locations page */
	// locations,
	contact,
	
	barBites,
	mainMenu,
	wineMenu,
	taxMenuCategories
})

/** Load Events */
routes.loadEvents()
